import React, { PureComponent } from 'react'

// local components
import TerminalItem from './TerminalItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const TerminalItemEditable = EditableHOCWrapper(TerminalItem)

class TerminalItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onTerminalUpdate(data, afterOnSave)
  }

  render() {
    const {
      terminal = {},
      lastModified = null,
      shops,
      defaultEditMode = false,
      onCancel,
      onDelete,
    } = this.props

    return (
      <TerminalItemEditable
        dataToEdit={terminal}
        onSave={this.onSave}
        lastModified={lastModified}
        shops={shops}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    )
  }
}

export default TerminalItemContainer



// WEBPACK FOOTER //
// ./src/components/Terminals/TerminalItemContainer.js